const _excluded = ["selected", "onChange", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import DatePicker from './DatePicker';
const DateTimePicker = _ref => {
  let {
      selected,
      onChange,
      className
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const transformDate = date => {
    const newDate = new Date();
    newDate.setHours(0, 0, 0, 0);
    return date ? new Date(date) : undefined;
  };
  return /*#__PURE__*/React.createElement(DatePicker, _extends({}, rest, {
    className: className,
    selected: transformDate(selected),
    showTime: true,
    showTimeSelect: true,
    onChange: onChange,
    shouldFormatDate: false
  }));
};
export default DateTimePicker;